import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20modern%20network%20gateway%20portal%20with%20warm%20amber%20and%20cream%20tones%2C%20flowing%20geometric%20shapes%20representing%20digital%20connectivity%2C%20soft%20gradient%20lighting%2C%20clean%20minimal%20tech%20aesthetic%20with%20subtle%20grid%20patterns%2C%20professional%20atmosphere%2C%20high-end%20editorial%20style&width=1800&height=900&seq=91n-hero-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/25"></div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
          <i className="ri-verified-badge-line text-accent-400 text-sm"></i>
          <span className="text-background-50 text-sm font-medium">官方认证入口指南 · 2026年8月更新</span>
        </div>
        <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight">
          91n com 官方入口
        </h1>
        <p className="text-lg md:text-xl text-background-50/90 mb-4 max-w-2xl mx-auto leading-relaxed">
          提供 91n com 最新访问地址、使用教程、常见问题解答及安全访问建议
        </p>
        <p className="text-sm md:text-base text-background-50/70 mb-8 max-w-xl mx-auto">
          帮助用户快速找到并正常使用 91n com 相关服务
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/tutorial"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            <i className="ri-book-open-line mr-2"></i>查看使用教程
          </Link>
          <Link
            to="/article/91n-com-zuixin-rukou-dizhi"
            className="w-full sm:w-auto px-8 py-3 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-semibold text-sm hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer text-center"
          >
            <i className="ri-link-m mr-2"></i>最新入口地址
          </Link>
        </div>
      </div>
    </section>
  );
}